// =============================================================================
// Lấy danh sách "Phân loại" (mục 1-7) ĐỘNG từ bảng qcv_score_infos, thay cho
// các mảng hardcode trước đây (SOLUTIONS_CONSTANTS, RESEARCH_CONSTANTS,...).
// value/key = code (vd "2.1"), title = description (theo cấu hình mùa giải).
// =============================================================================

// So khớp code với 1 "mục" (prefix). QCV dùng dạng "N.M"/"N.M-x" (mục = "N"),
// KVC dùng dạng lồng sâu hơn "N.M-x" (mục = "N.M", vd "1.1"->"1.1-a".."1.1-d").
// Khớp cả 3 kiểu: đúng bằng, nối thêm "." (kiểu QCV), hoặc nối thêm "-" (kiểu KVC).
const codeMatchesMuc = (code, mucPrefix) =>
  typeof code === "string" &&
  (code === mucPrefix || code.startsWith(`${mucPrefix}.`) || code.startsWith(`${mucPrefix}-`));

// scoreInformationList đã được reducer sort theo stt -> giữ nguyên thứ tự.
// programType: cột "type" trong qcv_score_infos dùng để tách chương trình
// dùng chung 1 bảng - QCV lưu 'qcv', KVC lưu '' (rỗng). Season_id đã tự tách
// biệt dữ liệu giữa các mùa/chương trình, nhưng vẫn lọc thêm cho chắc.
export const getQcvScoreOptions = (scoreInformationList, mucPrefix, programType = "qcv") =>
  (scoreInformationList || [])
    .filter((e) => (e?.type || "") === programType && codeMatchesMuc(e?.code, mucPrefix))
    .map((e) => ({ key: e.code, value: e.code, title: e.description }));

// Tra cứu nhanh 1 code -> { code, description, value } (dùng cho hiển thị cột
// "Phân loại", docx export, chấm điểm...).
export const findQcvScoreInfo = (scoreInformationList, code) =>
  (scoreInformationList || []).find(
    (e) => e?.type === "qcv" && e?.code === code
  );

// Tra nhãn hiển thị cho 1 giá trị "type/level/applicationRange" đã lưu, DÙNG
// CHUNG cho cả bản ghi MỚI (đã lưu thẳng code, vd "2.1") lẫn bản ghi CŨ/chưa
// migrate (vẫn còn giá trị cũ, vd "q1") -> ưu tiên tra theo code mới, không
// thấy thì fallback tra theo mảng hardcode cũ (fallbackOptions).
export const resolveQcvLabel = (scoreInformationList, mucPrefix, fallbackOptions, value, programType = "qcv") => {
  if (value == null || value === "") return undefined;
  const info = (scoreInformationList || []).find(
    (e) => (e?.type || "") === programType && e?.code === value && codeMatchesMuc(e?.code, mucPrefix)
  );
  if (info) return info.description;
  return (fallbackOptions || []).find((e) => e.value === value)?.title;
};

// Xác định 1 code (mục 2/3/5) là "trong nước" hay "quốc tế" dựa vào MÔ TẢ
// (chứa "trong nước" hay không) -> dùng để gộp nhóm/tính tổng điểm theo nhóm.
// Trả về null nếu value không phải code mới (để caller fallback theo mảng cũ).
export const isDomesticQcvCode = (scoreInformationList, mucPrefix, value, programType = "qcv") => {
  const info = (scoreInformationList || []).find(
    (e) => (e?.type || "") === programType && e?.code === value && codeMatchesMuc(e?.code, mucPrefix)
  );
  if (!info) return null;
  return !!info.description?.includes("trong nước");
};

// Khi lấy dữ liệu từ DOI, chỉ tự động chọn "Phân loại" nếu quartile (Q1/Q2..)
// khớp ĐÚNG với 1 trong các lựa chọn hiện có (theo description). Không cố đoán
// khi không khớp (vd Scopus không rõ quartile, hoặc Q3/Q4 chưa có trong bảng
// điểm mùa này) -> để trống, ứng viên tự chọn trong dropdown.
export const matchQuartileOption = (options, journal) => {
  if (journal?.coreCollection === "Scopus") return undefined;
  const quartile = journal?.sjrBestQuartile?.toUpperCase();
  if (!quartile) return undefined;
  return (options || []).find((o) =>
    o.title?.toUpperCase().includes(quartile)
  )?.value;
};
